module.exports = __webpack_public_path__ + "img/摄图网_500768930_banner@2x.98831bf0.png";